import React, { useRef, Children } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const competencies = ['Operations Strategy & Execution', 'Lean / Six Sigma Manufacturing', 'Aviation MRO Management', 'Supply Chain Optimization', 'P&L & Budget Management', 'FAA Regulatory Compliance', 'AS9100 / ISO 9001 Quality', 'Workforce Development', 'Cross-functional Leadership', 'Production Planning & Control', 'Safety Management Systems', 'Continuous Process Improvement', 'ERP Systems (SAP / Oracle)', 'Demand Forecasting', 'Multi-site Operations', 'Executive Stakeholder Engagement', 'Risk Management', 'Lifecycle Logistics'];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.06
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20,
    scale: 0.97
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: 'easeOut'
    }
  }
};
const headingVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function CompetenciesGrid() {
  const ref = useRef<HTMLElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section id="competencies" ref={ref} className="py-20" style={{
    backgroundColor: '#f8fafc'
  }} data-id="element-44">
      <div className="max-w-5xl mx-auto px-6" data-id="element-45">
        {/* Section heading */}
        <motion.div variants={headingVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} className="mb-12 text-center" data-id="element-46">
          <h2 className="font-display" style={{
          fontFamily: 'Playfair Display, serif',
          fontSize: 'clamp(28px, 4vw, 38px)',
          fontWeight: 700,
          letterSpacing: '0.05em',
          color: '#0d1b4b'
        }} data-id="element-47">
            CORE COMPETENCIES
          </h2>
          <div className="mx-auto mt-4 h-px w-24" style={{
          background: 'linear-gradient(to right, transparent, var(--gold), transparent)'
        }} data-id="element-48" />
          <p className="mt-4" style={{
          fontFamily: 'Inter, sans-serif',
          fontSize: '14px',
          color: '#6b7280',
          letterSpacing: '0.02em'
        }} data-id="element-49">
            Comprehensive leadership capabilities spanning operations, aviation,
            and technical execution
          </p>
        </motion.div>

        {/* 3-column card grid */}
        <motion.div variants={containerVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-50">
          {competencies.map(competency => <motion.div key={competency} variants={itemVariants} className="flex items-center gap-3 px-4 py-3.5 rounded-md bg-white" style={{
          border: '1px solid rgba(13,27,75,0.1)',
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }} data-id="element-51">
              <CheckCircleIcon size={17} style={{
            color: '#1a3a8f',
            flexShrink: 0
          }} data-id="element-52" />
              <span style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '13.5px',
            fontWeight: 500,
            color: '#1f2937',
            lineHeight: 1.4
          }} data-id="element-53">
                {competency}
              </span>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}